// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require("core/apiURLBuilder.js");

// @ constants
const actionTypes = require('constants/actionTypes');
const { statusMapping } = require('constants/openYoungHistory');

const openYoungHistoryFetching = () => ({
    type: actionTypes.OPENYOUNG_HISTORY_IS_FETCHING
});

const openYoungHistorySuccess = (response, childDetails, isFilterSelected) => ({
    type: actionTypes.OPENYOUNG_HISTORY_SUCCESS,
    payload: {
        response,
        childDetails,
        isFilterSelected
    }
});

const openYoungHistoryFailure = error => ({
    type: actionTypes.OPENYOUNG_HISTORY_FAILURE,
    payload: error
});

const resetOpenYoungHistory = () => ({
    type: actionTypes.OPENYOUNG_HISTORY_RESET
})

const setOpenYoungFilter = filters => dispatch => {
    dispatch({
        type: actionTypes.OPENYOUNG_HISTORY_FILTER,
        payload: {
            filters
        }
    })
}

const resetOpenYoungHistoryFilter = filterKey => dispatch => { // used to remove a single filter at a time
    dispatch({
        type: actionTypes.OPENYOUNG_HISTORY_RESET_FILTER,
        payload: {
            filterKey
        }
    });
};

const requestClearOpenYoungFilter = () => dispatch =>{
    dispatch({
        type: actionTypes.OPENYOUNG_HISTORY_CLEAR_FILTER,
    });
}

const getOpenYoungHistory = (isCardDetailsTab, nextPage) => (dispatch, getState) => {
    const immOpenYoungDashboard = getState().openYoungDashboard;
    const immFilters = getState().openYoungHistory.get('filters');
    const childDetails = {};
    const endpoint = !!isCardDetailsTab ? "openYoungChildMoneyRequestDetails" : "openYoungChildSaveMoneyRequestDetails";
    let childsPan;
    immOpenYoungDashboard.get('openYoungChildList').filter(child => {
        if (!!child.getIn(['card','pan'])) {
            childDetails[child.getIn(['card','pan'])] = child.get('childName');
        }
    });
    childsPan = Object.keys(childDetails);
    const dateIsActive = immFilters.getIn(['date', 'isActive']);
    const amountIsActive = immFilters.getIn(['amount', 'isActive']);
    const isChildSelected = immFilters.getIn(['childList', 'isActive']);
    const statusIsActive = immFilters.getIn(['status', 'isActive']);
    let requestStartDate;
    let requestStatus;
    let requestEndDate;
    let minAmount;
    let maxAmount;
    if (statusIsActive) {
        requestStatus = statusMapping[immFilters.getIn(['status', 'status'])]
    }
    if (dateIsActive) {
        requestStartDate = immFilters.getIn(['date', 'from']);
        requestEndDate = immFilters.getIn(['date', 'to']);
    }
    if (amountIsActive) {
        minAmount = immFilters.getIn(['amount','from','amount']);
        maxAmount = immFilters.getIn(['amount','to','amount']);
    }
    if (isChildSelected) {
        childsPan = immFilters.getIn(['childList','childsPan'])
        .filter(immChild => immChild.get('isSelected'))
        .map(immChild => immChild.get('pan'))
        .toJS();
    }
    const isFilterSelected = statusIsActive || dateIsActive || amountIsActive || isChildSelected;
    const requestData = {
        query: {
            childsPan,
            requestStatus,
            requestStartDate,
            requestEndDate,
            minAmount,
            maxAmount
        }
    };
    if (!isFilterSelected && !nextPage) {
        dispatch(resetOpenYoungHistory());
    }
    const url = nextPage || apiURLBuilder.getURL(endpoint);
    dispatch(openYoungHistoryFetching());

    return APIPost({
        dispatch,
        url,
        params: requestData
     })
        .then(response => {
            dispatch(openYoungHistorySuccess(response, childDetails, isFilterSelected));
        })
        .catch((response) => {
            if (!!response.error) {
                dispatch(openYoungHistoryFailure(response.error));
            }else {
                throw response;
            }
        });
};

module.exports = {
    getOpenYoungHistory,
    requestClearOpenYoungFilter,
    resetOpenYoungHistory,
    resetOpenYoungHistoryFilter,
    setOpenYoungFilter,
};